<div class="d-flex align-items-center">
    <div>
        <fa-icon [fixedWidth]="true"
                 [icon]="['far', notification.notification_type | notificationIcon: notification.notification_sub_type]"
                 class="text-primary mr-4" size="lg">
        </fa-icon>
    </div>

    <div class="flex-grow-1">
        <div class="text-dark overflow-hidden text-nowrap text-truncate">
            <a [ngClass]="{'font-weight-normal': notification.read}" class="h6 mb-1 d-inline-block text-dark"
               href="javascript:void(0);">
                {{ notification.subject }}
            </a>
        </div>
        <div class="text-muted">
            <span [pTooltip]="notification.received_at | amLocal | amDateFormat: 'LLL'"
                  style="cursor: pointer;">
                {{ 'common.received' | translate }} {{ notification.received_at | amTimeAgo }}
            </span>
            <ng-container [ngSwitch]="notification.entity.type">
                <ng-container *ngSwitchCase="EntityType.ShipmentPortal">
                    &bull;
                    <a [routerLink]="['/my-portal/shipments/', notification.entity.id]">
                        {{ notification.entity.title }}
                    </a>
                </ng-container>
                <ng-container *ngSwitchCase="EntityType.ShipmentDomain">
                    &bull;
                    <a [routerLink]="['/my-portal/shipments/', notification.entity.id]">
                        {{ notification.entity.title }}
                    </a>
                </ng-container>
                <ng-container *ngSwitchCase="EntityType.Quotation">
                    &bull;
                    <a [routerLink]="['/my-portal/quotations/', notification.entity.id]">
                        {{ notification.entity.title }}
                    </a>
                </ng-container>
                <ng-container *ngSwitchCase="EntityType.SavedSchedule">
                    &bull;
                    <a [routerLink]="['/my-portal/schedules/saved/', notification.entity.id]">
                        {{ notification.entity.title }}
                    </a>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <a
        pTooltip="User options"
        class="options-dd-toggle ml-1 text-muted"
        (click)="dropdownMenu.toggle($event)"
        [ngClass]="{ rotate: dropdownMenu.overlayVisible }"
    >
        <fa-icon
            [icon]="['fas', 'ellipsis-v']"
            class="d-inline-block"
            [fixedWidth]="true"
        >
        </fa-icon>
    </a>
    <p-overlayPanel #dropdownMenu>
        <ul class="list-group list-group-flush" style="min-width: 200px;">
            <button (click)="onToggleRead($event)" class="list-group-item list-group-item-action">
                <fa-icon [icon]="['far', notification.read ? 'envelope-open' : 'envelope']"></fa-icon>
                {{ 'portal.notifications.mark-as' | translate }} {{ (notification.read ? 'common.unread' : 'common.read') | translate }}
            </button>
            <button (click)="onDelete($event)" class="list-group-item list-group-item-action">
                <fa-icon [icon]="['far', 'trash']"></fa-icon>
                {{ 'common.delete' | translate }}
            </button>
        </ul>
    </p-overlayPanel>
</div>

<div *ngIf="false" [ngClass]="{'bg-light': expanded}" class="notification-wrapper d-flex align-items-center p-1">
    <fa-icon [fixedWidth]="true"
             [icon]="['far', notification.notification_type | notificationIcon: notification.notification_sub_type]"
             class="text-muted mr-4" size="lg">
    </fa-icon>
    <div class="flex-grow-1">
        <div class="d-flex justify-content-between">
            <div [ngClass]="{'font-weight-bold': !notification.read}" class="subject">{{notification.subject}}</div>
            <div class="text-muted small">{{ notification.received_at | amTimeAgo }}</div>
        </div>
        <ng-container [ngSwitch]="notification.entity.type">
            <a *ngSwitchCase="EntityType.ShipmentPortal"
               [routerLink]="['/my-portal/shipments/', notification.entity.id]">{{ notification.entity.title }}</a>
            <a *ngSwitchCase="EntityType.ShipmentDomain"
               [routerLink]="['/my-portal/shipments/', notification.entity.id]">{{ notification.entity.title }}</a>
            <a *ngSwitchCase="EntityType.Quotation"
               [routerLink]="['/my-portal/quotations/', notification.entity.id]">{{ notification.entity.title }}</a>
            <a *ngSwitchCase="EntityType.SavedSchedule"
               [routerLink]="['/my-portal/schedules/saved/', notification.entity.id]">{{ notification.entity.title }}</a>
        </ng-container>
    </div>

    <div *ngIf="hover" class="actions bg-light d-flex align-items-center">
        <button (click)="onToggleRead($event)" pTooltip="{{ 'portal.notifications.mark-as' | translate }} {{ (notification.read ? 'common.unread': 'common.read') | translate }}"
                class="btn btn-icon">
            <fa-icon [icon]="['far', notification.read ? 'envelope-open' : 'envelope']"></fa-icon>
        </button>
        <button (click)="onDelete($event)" class="btn btn-icon" pTooltip="{{ 'common.delete' | translate }}">
            <fa-icon [icon]="['far', 'trash']"></fa-icon>
        </button>
    </div>
</div>

<qwyk-notification-detail *ngIf="expanded" [notification]="notification"></qwyk-notification-detail>
